function getChildren(n, skipMe) {
  var r = [];
  for ( ; n; n = n.nextSibling )
    if ( n.nodeType == 1 && n != skipMe)
      r.push( n );
  return r;
};

function getSiblings(n) {
  return getChildren(n.parentNode.firstChild, n);
}

const videoPlay = function () {
  const videoGridSections = document.querySelectorAll('.grid-videos');
  if (videoGridSections.length > 0) {
    videoGridSections.forEach(section => {
      const playPauseButtons = section.querySelectorAll('.grid-videos__item-buttons button');
      const videoComponents = section.querySelectorAll('video-component');

      //for full screen video with new btn
      if (playPauseButtons.length > 0) {
        playPauseButtons.forEach( button => {
          button.addEventListener('click', function(e) {
            const parent = this.closest('.grid-videos__item');

            if (!parent) return;
            const siblingElem = getSiblings(this);
            const textWrapper = parent.querySelector('.grid-videos__item-text-wrapper');
            const customVideo = parent.querySelector('video-component');
            let defaultCustomButtonPlayIcon;
            let defaultCustomButtonPauseIcon;

            if(customVideo.playBtn) defaultCustomButtonPlayIcon = customVideo.playBtn.querySelector('svg');
            if(customVideo.pauseBtn) defaultCustomButtonPauseIcon = customVideo.pauseBtn.querySelector('svg');


            customVideo.showHideButton(this, false);
            customVideo.showHideButton(siblingElem[0], true);

            if(this.getAttribute('aria-label') === 'Pause Video') {
              customVideo.playerPause();
            } else {
              customVideo.playerPlay();
              if(defaultCustomButtonPlayIcon) defaultCustomButtonPlayIcon.style.display = 'block';
              if(defaultCustomButtonPauseIcon) defaultCustomButtonPauseIcon.style.display = 'block';
              customVideo.hideElement(textWrapper);
            }
          })
        })
      }

      if(videoComponents.length > 0) {
        videoComponents.forEach( customVideoElement => {
          const parent = customVideoElement.closest('.grid-videos__item');

          if (!parent) return;
          const textWrapper = parent.querySelector('.grid-videos__item-text-wrapper');

          customVideoElement.addEventListener('click', function(e) {
            if(customVideoElement.classList.contains('is-playing')) {
              customVideoElement.hideElement(textWrapper);
            }
          })
        })
      }

    })
  }
};

export default videoPlay;